module.exports = __webpack_public_path__ + "static/colors-929a62cfa16c975cf2b2ef85211f09be.png";